export default function deepCopy (obj) {
  let cache = []
  let copy = JSON.parse(JSON.stringify(obj, function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (cache.indexOf(value) !== -1) {
        // Duplicate reference found
        try {
          // If this value does not reference a parent it can be deduped
          return JSON.parse(JSON.stringify(value))
        } catch (error) {
          // discard key if value cannot be deduped
          return
        }
      }
      // Store value in our collection
      cache.push(value)
    }
    return value
  }))
  cache = null
  return copy
}
